import * as React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';
import IconButton from 'ha/ui/next/IconButton';
import { ChevronLeftIcon, ChevronRightIcon } from 'ha/ui/next/Icons';
import { ControlProps } from 'ha/components/next/Slider';

export const styles = createStyles({
  root: {
    boxShadow: '0 2px 9px 0 rgba(0, 0, 0, 0.11)',
  },
});

interface Props {
  direction: 'left' | 'right';
}

export const SliderControl: React.SFC<Props & ControlProps & WithStyles> = ({
  previousSlide,
  nextSlide,
  direction,
  classes,
}) => {
  const isLeft = direction === 'left';

  return (
    <IconButton
      className={classes.root}
      onClick={isLeft ? previousSlide : nextSlide}
    >
      {isLeft ? (
        <ChevronLeftIcon color="secondary" />
      ) : (
        <ChevronRightIcon color="secondary" />
      )}
    </IconButton>
  );
};

export default withStyles(styles)(SliderControl);
